import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import {
  Button,
  Card,
  CardContent,
  CardMedia,
  Link,
  TextField,
} from '@material-ui/core';
import PropTypes from 'prop-types';

import * as events from '../../../events';
import * as actions from '../../../state';
import styles from './styles.module.css';
import LoginMessageSnackbar from './LoginMessageSnackbar';

const messages = defineMessages({
  ANALYTICS: {
    id: 'ANALYTICS',
    defaultMessage: 'Analytics',
  },
  LOGO: {
    id: 'LOGO',
    defaultMessage: 'Logo',
  },
  ENROLL: {
    id: 'ENROLL',
    defaultMessage: 'Enroll',
  },
  USERNAME_REQUIRED: {
    id: 'USERNAME_REQUIRED',
    defaultMessage: 'Username required',
  },
  PASSWORD_REQUIRED: {
    id: 'PASSWORD_REQUIRED',
    defaultMessage: 'Password required',
  },
  LOGIN_NAME: {
    id: 'LOGIN_NAME',
    defaultMessage: 'Login Name',
  },
  PASSWORD: {
    id: 'PASSWORD',
    defaultMessage: 'Password',
  },
  RETURN_TO_LOGIN: {
    id: 'RETURN_TO_LOGIN',
    defaultMessage: 'Return to login',
  },
  ENTER_USER_CREDENTIALS: {
    id: 'ENTER_USER_CREDENTIALS',
    defaultMessage: 'Enter the login name and password of the account you want to enroll into single sign-on.',
  },
});

function SsoEnroll({ idtoken, intl, vendor }) {
  const dispatch = useDispatch();

  const loginImage = useSelector(actions.selectLoginImage);

  const [username, setUsername] = useState('');
  const [usernameErr, setUsernameErr] = useState('');
  const [password, setPassword] = useState('');
  const [passwordErr, setPasswordErr] = useState('');
  const [authAttempted, setAuthAttempted] = useState(false);

  const onPasswordChange = (e) => {
    setPassword(e.target.value);

    if (!e.target.value) {
      setPasswordErr(intl.formatMessage({ ...messages.PASSWORD_REQUIRED }));
    } else {
      setPasswordErr('');
    }
  };

  const onUsernameChange = (e) => {
    setUsername(e.target.value);

    if (!e.target.value) {
      setUsernameErr(intl.formatMessage({ ...messages.USERNAME_REQUIRED }));
    } else {
      setUsernameErr('');
    }
  };

  const ssoEnroll = (e) => {
    e.preventDefault();

    if (!username) {
      setUsernameErr(intl.formatMessage({ ...messages.USERNAME_REQUIRED }));
      setPasswordErr('');
      setAuthAttempted(true);
    } else if (!password) {
      setUsernameErr('');
      setPasswordErr(intl.formatMessage({ ...messages.PASSWORD_REQUIRED }));
      setAuthAttempted(true);
    } else {
      dispatch(events.ssoEnrollSubmit(
        username,
        password,
        idtoken,
        vendor,
      ));
    }
  };

  const resetForm = () => {
    setAuthAttempted(false);
  };

  return (
    <div className={`${styles.loginCard} animate__animated animate__fadeIn`}>
      <Card className={styles.card}>
        <CardMedia
          className={styles.media}
          image={loginImage}
          title={intl.formatMessage({ ...messages.LOGO })}
        />

        <CardContent className={styles.content} classes={{ root: styles.loginFormCard }}>
          <div style={{ color: '#333' }}>
            <FormattedMessage {...messages.ENTER_USER_CREDENTIALS} />
          </div>

          <form onSubmit={ssoEnroll} noValidate style={{ marginTop: '7px' }}>
            <TextField
              required
              id="name"
              margin="normal"
              onFocus={resetForm}
              className={styles.textField}
              onBlur={onUsernameChange}
              onChange={onUsernameChange}
              label={intl.formatMessage({ ...messages.LOGIN_NAME })}
              error={authAttempted && Boolean(usernameErr)}
            />
            <TextField
              required
              id="password"
              type="password"
              onFocus={resetForm}
              className={styles.textField}
              onBlur={onPasswordChange}
              onChange={onPasswordChange}
              label={intl.formatMessage({ ...messages.PASSWORD })}
              error={authAttempted && Boolean(passwordErr)}
            />
            <Button
              fullWidth
              size="large"
              type="submit"
              color="primary"
              variant="contained"
              className={styles.loginBtn}
            >
              <FormattedMessage {...messages.ENROLL} />
            </Button>
            <div className={styles.connectAccountContainer}>
              <Link to="/" onClick={() => dispatch(actions.showLoginFormPage())}>
                <FormattedMessage {...messages.RETURN_TO_LOGIN} />
              </Link>
            </div>
          </form>
        </CardContent>
      </Card>

      <LoginMessageSnackbar />

    </div>
  );
}

SsoEnroll.propTypes = {
  idtoken: PropTypes.string.isRequired,
  intl: PropTypes.shape({}).isRequired,
  vendor: PropTypes.string.isRequired,
};

export default injectIntl(SsoEnroll);
